var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlamingoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129.611,
    height: 42.576,
    viewBox: "0 0 129.611 42.576",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_625",
    "data-name": "Group 625",
    transform: "translate(0.001 0.006)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Flamingo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FLAMINGO-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_898",
    "data-name": "Group 898"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M36.14,18.26H31.22v4.36h4.55v1.33H31.22v5.58H29.74V16.93h6.4v1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M46.87,29.53H40.33V16.93h1.48V28.2h5.06v1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M60.89,29.53H59.26L57.92,26H52.58l-1.26,3.53H49.68l4.83-12.6h1.53Zm-3.45-4.86L55.46,19.3a5.45,5.45,0,0,1-.19-.84h-.04a5.227,5.227,0,0,1-.2.84l-1.96,5.37h4.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3767",
    "data-name": "Path 3767",
    d: "M77.39,29.53H75.92V21.07c0-.67.04-1.49.12-2.45H76a7.563,7.563,0,0,1-.38,1.22l-4.31,9.69h-.72l-4.3-9.62a7.822,7.822,0,0,1-.38-1.29h-.04c.05.5.07,1.33.07,2.47v8.44H64.52V16.93h1.95l3.87,8.79a11.391,11.391,0,0,1,.58,1.51h.05c.25-.69.45-1.21.61-1.55l3.95-8.75h1.85v12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3768",
    "data-name": "Path 3768",
    d: "M83.98,29.53H82.5V16.93h1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3769",
    "data-name": "Path 3769",
    d: "M99.25,29.53H97.44L90.95,19.48a4.189,4.189,0,0,1-.4-.79H90.5a12.48,12.48,0,0,1,.07,1.73v9.11H89.09V16.93h1.92l6.31,9.89q.39.615.51.84h.04a12.949,12.949,0,0,1-.09-1.85V16.93h1.48v12.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3770",
    "data-name": "Path 3770",
    d: "M113.78,28.67a8.485,8.485,0,0,1-4.22,1.07A5.754,5.754,0,0,1,105.2,28a6.4,6.4,0,0,1-1.67-4.61,6.625,6.625,0,0,1,1.85-4.8,6.314,6.314,0,0,1,4.69-1.88,7.89,7.89,0,0,1,3.45.67v1.63a6.682,6.682,0,0,0-3.62-.97,4.56,4.56,0,0,0-3.47,1.46,5.336,5.336,0,0,0-1.35,3.78,5.41,5.41,0,0,0,1.26,3.76,4.407,4.407,0,0,0,3.41,1.37,5.318,5.318,0,0,0,2.56-.59V24.29h-2.76V22.95h4.24v5.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3771",
    "data-name": "Path 3771",
    d: "M123.59,29.74a5.508,5.508,0,0,1-4.29-1.77,6.581,6.581,0,0,1-1.61-4.6,6.947,6.947,0,0,1,1.64-4.85,5.757,5.757,0,0,1,4.47-1.81,5.435,5.435,0,0,1,4.21,1.76,6.542,6.542,0,0,1,1.6,4.6,6.97,6.97,0,0,1-1.63,4.88,5.62,5.62,0,0,1-4.38,1.79Zm.11-11.69a4.1,4.1,0,0,0-3.23,1.43,5.518,5.518,0,0,0-1.24,3.76,5.579,5.579,0,0,0,1.21,3.75,3.942,3.942,0,0,0,3.15,1.42,4.152,4.152,0,0,0,3.27-1.35,5.524,5.524,0,0,0,1.2-3.79,5.887,5.887,0,0,0-1.16-3.86A3.967,3.967,0,0,0,123.7,18.05Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape_10",
    "data-name": "Shape 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M4.29,20.57S2.54,19.3,2.14,14.83c0,0-3.4,5.95-.72,9.56a10.564,10.564,0,0,0,4.06,3.59s-2.4-4.62-1.19-7.41Z",
    fill: "#a3eaf4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_11",
    "data-name": "Shape 11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M4.53,20.57a36.585,36.585,0,0,0,5.5.96l3.35,1.19a11.585,11.585,0,0,1,4.06,3.59l2.39,3.82c-.94-15.2-15.3-9.56-15.3-9.56h0Z",
    fill: "#feb478"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_18",
    "data-name": "Shape 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M4.05,3.16l.26.27,1.56-.27.78.27a5.594,5.594,0,0,0,1.31.55c.27-.01.52,1.38.52,1.38L8.22,6.75l.52,1.38L9.78,6.75c-.02-8.68-5.74-3.6-5.74-3.6h0Z",
    fill: "#eae4a4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape_8",
    "data-name": "Shape 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M20.12,31.51a.142.142,0,0,1,.02-.04C20.14,31.48,20.13,31.49,20.12,31.51Zm-1.83-11.2a10.3,10.3,0,0,0-4.94-2.98c-6.06-1.66-9.03,2.69-9.03,2.69-1.57-.69-1.41-3.4-1.41-3.4a8.143,8.143,0,0,1,1.41-3.83c.24-.27,2.12-2.12,2.12-2.12.41-.26,2.82-2.69,2.82-2.69a8.7,8.7,0,0,0,1.97-4.11A3.675,3.675,0,0,0,9.96.89C7.36-1.04,5.59.75,5.59.75,3.94,1.51,3.9,3.87,3.9,3.87L1.78,5.43c-.11.78.57.42.57.42A13.409,13.409,0,0,1,5.17,4.01c3.38-.57,2.97,1.56,2.97,1.56.34,1.46-1.83,3.97-1.83,3.97-.2.33-3.25,3.54-3.25,3.54C1.79,14.13.23,18.04.23,18.04c-1.43,7.36,4.24,9.78,4.24,9.78a.594.594,0,0,1,.08.04,11.39,11.39,0,0,1,1.54.92l.39.44a.319.319,0,0,0,.06.07L11.71,35v7.1h.09v.05h.7V42.1h.16V36.05l5.91,6.52.57-.42L12.67,34.9V28.94l1.96-.26a5.985,5.985,0,0,1,1.83.29,8.091,8.091,0,0,1,3.53,2.83.974.974,0,0,0,.14-.29l-.02-.25q.045-.1.15-.33h.02a4.277,4.277,0,0,1-.12.54c.19-.49.36-.99.5-1.49a1.862,1.862,0,0,0,.15-.56c0-.01-.01-.01-.01-.02a9.881,9.881,0,0,0-2.49-9.08H18.3ZM7.84,3.59a3.455,3.455,0,0,0-3.1-.14S4.82-.01,8.98,1.04a3.08,3.08,0,0,1,1.55,2.83A7.3,7.3,0,0,1,8.28,7.98s1.66-3.24-.42-4.4H7.85ZM5.16,27.62c-.04-.05-.07-.11-.11-.17A8.53,8.53,0,0,1,.79,22.02a11.18,11.18,0,0,1,1.55-6.94c-.93,4.73,1.69,5.67,1.69,5.67a6.856,6.856,0,0,0,.99,6.66c0,.02.02.03.03.05.1.05.22.1.32.14l-.21.03h0Zm6.54,6.1v.1L7.23,28.81H7.08a.968.968,0,0,1,.07-.09l.09.1h.04c.78.1,3.17.13,4.43.14v4.76h0Zm.09-4.78v-.12h.03s.03.08.04.12Zm5.08-.54a6.435,6.435,0,0,0-3.81-.14c-.62.12-3.81.14-3.81.14a9.584,9.584,0,0,1-2.82-.42l-.26-.26a13.044,13.044,0,0,1-1.44-2.3c-.89-1.57-.14-4.4-.14-4.4.53.5,4.52.85,4.52.85,4.94,1.04,5.36,1.99,5.36,1.99a9.977,9.977,0,0,1,3.25,3.4,18.538,18.538,0,0,1,1.17,2.2v.12a8.861,8.861,0,0,0-2.02-1.17h0Zm3.31.89c-.18.02-.36.04-.52.07a21.7,21.7,0,0,0-2.65-4.22,10.657,10.657,0,0,0-4.8-3.26,19.208,19.208,0,0,0-4.24-.85c-.55-.08-2.68-.42-2.68-.42-.36-.12-.28-.29-.28-.29a6.033,6.033,0,0,1,2.26-1.84,8.976,8.976,0,0,1,10.16,1.99c1.95,1.52,2.82,5.1,2.82,5.1a9.142,9.142,0,0,1-.07,3.72h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlamingoLogo);
export default __webpack_public_path__ + "static/media/flamingo-logo.4bb4df332d0b564367d4a5d977902057.svg";
export { ForwardRef as ReactComponent };